var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col overflow-hidden h-screen bg-lightest-grey",attrs:{"id":"app"}},[_c('Header'),_c('PageContainer',[(_vm.error)?_c('div',{staticClass:"notification is-danger"},[_vm._v(_vm._s(_vm.error))]):_c('router-view')],1),_c('Toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }